// src/components/layout/Layout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      {/* scroll-pt = navbar height for anchor links */}
      <main className="flex-grow scroll-pt-[72px]">
        {children}
      </main>
      <Footer />
    </div>
  );
}
